/**
 * Copy for the "i" on the lesson-count and course-duration rows.
 *
 * Sekretariatet afviser mange kursusbeviser, fordi varigheden af de enkelte
 * lektioner ikke fremgår, og kravet stod ingen steder i medlemmets egen
 * brugerflade. Ordlyden er sekretariatets — ret den ikke uden dem.
 */
const CourseTimeInfoContent = () => (
  <div className="d-flex flex-column gap-2">
    <p className="mb-0">
      Godkendelse af et kursusbevis kræver dokumentation for både, hvordan
      antallet af de angivne lektioner er opgjort, og dokumentation for det
      nærmere indhold af de enkelte lektioner. Det skal kunne dokumenteres ved
      upload af dine kursusbeviser.
    </p>
    <p className="mb-0">
      For at dokumentere indholdet af et kursus er det nødvendigt, at et
      kursusbevis indeholder eller bilægges oplysninger om indholdet af de
      enkelte lektioner, som kursusbeviset måtte angive.
    </p>
    <p className="mb-0">
      For at dokumentere antallet af lektioner, som et kursus kan opgøres til at
      omfatte, er det nødvendigt, at varigheden af kursets enkelte lektioner og
      dermed den reelle undervisningstid fremgår. Pauser og forberedelsestid som
      måtte være inkluderet i kursets samlede varighed, kan eksempelvis ikke
      medregnes.
    </p>
    <p className="mb-0">
      Et kursusprogram indeholder typisk både oplysning om indholdet af de
      enkelte lektioner og oplysninger om varigheden af undervisningen, og om
      kursets eventuelle pauser, og kan derfor ofte bruges som dokumentation for
      disse forhold. Der er derfor brug for, at kursusprogrammet eller
      oplysningerne herfra enten fremgår specificeret på kursusbeviset, eller at
      selve kursusprogrammet vedlægges kursusbeviset.
    </p>
  </div>
);

export default CourseTimeInfoContent;
